var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.type == 'title')?_c('div',{staticStyle:{"margin-left":"5px"},style:(_vm.item.styles)},[_vm._v(" "+_vm._s(_vm.item.value)+" ")]):_c(_vm.getComponent(_vm.item.type, _vm.item.component),_vm._b({tag:"component",attrs:{"multiple":false,"placeholder":_vm.item.placeholder || _vm.getPlaceholder(_vm.item),"dic":_vm.item.dicData,"value":['time', 'timerange', 'checkbox'].includes(_vm.item.type)
        ? _vm.item.dicData
        : undefined}},'component',
      Object.assign(_vm.deepClone(_vm.item), _vm.params, { size: _vm.item.size || 'small' })
    ,false),[(_vm.params.html)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.params.html)}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }